import { render, staticRenderFns } from "./RequestFile.vue?vue&type=template&id=54a4af69&scoped=true&"
import script from "./RequestFile.vue?vue&type=script&lang=js&"
export * from "./RequestFile.vue?vue&type=script&lang=js&"
import style0 from "./RequestFile.vue?vue&type=style&index=0&id=54a4af69&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54a4af69",
  null
  
)

export default component.exports